import type { PatchOutlookSpace, TimeStreamProject } from 'owa-timestream-types';
import refreshArray from '../refreshArray';

export default function updateProjectWithPatch(project: TimeStreamProject, s: PatchOutlookSpace) {
    'name' in s && (project.name = s.name || '');
    'description' in s && (project.description = s.description || '');
    'categories' in s && refreshArray(project.categories, s.categories);
    'keywords' in s && refreshArray(project.keywords, s.keywords);
    'people' in s && refreshArray(project.people, s.people);
    'image' in s && (project.image = s.image || '');
    'tasksParentFolderId' in s && (project.tasksParentFolderId = s.tasksParentFolderId || '');
    'unseenCapturedCount' in s && (project.unseenCapturedCount = s.unseenCapturedCount || 0);
    'templateType' in s && (project.templateType = s.templateType || '');
    'appName' in s && (project.appName = s.appName || '');
    'backgroundColor' in s && (project.backgroundColor = s.backgroundColor || '');
}
